import { Component } from "@basic-orange/component";

export default class VacancySticky extends Component {
    constructor(elm, componentId) {
        super(elm, componentId);

        setTimeout(() => {
            this.$elm = $(elm);
            this.elmBoundingBox = $.rectangle(elm);
            this.$article = $('article');
            this.$header = $('.header');
            this.$title = $('article h1');

            this.stickyPoint = this.$title.offset().top;

            this.setEventListeners();

            this.init();
        }, 400);
    }

    init() {
        setTimeout(() => {
            var scrollPosition = $(window).scrollTop() + 1;
            $(window).scrollTo(scrollPosition, 1);
        }, 400);
    }

    setEventListeners() {
        $(window)
            .on('scroll', this.onScroll.bind(this));
    }

    onScroll(event) {
        var scrollTop = $(window).scrollTop();
        var headerBoundingBox = $.rectangle($("header"));

        //var scrollDirectionIsDown = (scrollTop > this.lastScrollTop);

        if (scrollTop > this.stickyPoint) {
            this.$elm
                .css({ marginTop: headerBoundingBox.height + 'px' })
                .addClass('umb-tpl-Vacancy-contentSticky--isSticky');

            //this.$article.css({ marginTop: (headerBoundingBox.height + elmBoundingBox.height + 64) + 'px' });
            this.$header.addClass('header--inpageNavigationIsFixed');
        } else {
            this.$elm
                .css({ marginTop: 0 })
                .removeClass('umb-tpl-Vacancy-contentSticky--isSticky');

            this.$article.css({ marginTop: 0 });
            this.$header.removeClass('header--inpageNavigationIsFixed');
        }

        this.lastScrollTop = scrollTop;
    }
}